// removed by extract-text-webpack-plugin
module.exports = {"app":"app_index"};


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 226
// module chunks = 0